import React, { useState } from "react";
import { Container, Row, Col, Form, Button, Card, InputGroup } from "react-bootstrap";
import {
  handleLoginAction,
  handleLogoutAction,
} from "../../store/actions/userActions";
import { useDispatch, useSelector } from "react-redux";
import { FaSearch, FaEye, FaEyeSlash, FaUserPlus } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/icons/logo.svg";
import { IMAGES } from "../../constants/constants";
import "../../styles/Dashboard.css";
import "./login.css";
import Cookies from "js-cookie";
import Loader from "../../assets/images/loader.gif";
function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.user);
  const [showLogoutButton, setShowLogoutButton] = useState(false);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
 const [showPassword, setShowPassword] = useState(false); // Add this line at the top with other state variables

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev); // Toggle the password visibility
  };
  const handleChange = (e) => {
    const { name, value } = e.target;

    // Clear the error for the field that is being changed
  setErrors((prevErrors) => ({
    ...prevErrors,
    [name]: "", // Reset the specific field error on change
  }));
  
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };


  const validateForm = () => {
    const newErrors = {};
    // Email validation
    if (!formData.email) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Email format is invalid";
    }

    // Password validation
    if (!formData.password) {
      newErrors.password = "Password is required";
    } else if (formData.password.length < 6) {
      newErrors.password = "Password must be at least 6 characters";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Returns true if no errors
  };

  const [logoutuserid, setLogoutUserId] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
     // Validate form before submitting
     if (!validateForm()) {
      return;
    }

    const result = await handleLoginAction(formData, dispatch);
    if (result.isLoading) {
      return (
        <div className="loaderOverlay">
          <img src={Loader} alt="Loader" />
        </div>
      );
    }
    // if (result.success) {
    //   navigate("/dashboard");
    //   setFormData({ email: "", password: "" });
    // } else {
    //   // console.error("Login failed");

    //   if (result.error === "ALREADY LOGGED IN ON SOME OTHER DEVICE") {
    //   //   navigate("/dashboard");
    //   // setFormData({ email: "", password: "" });
    //     setLogoutUserId(result.userId); // Set the userId in state
    //     setShowLogoutButton(true);
    //   }
    // }

    if (result.success) {
      navigate("/dashboard");
      setFormData({ email: "", password: "" });
    } else {
      if (result.error === "ALREADY LOGGED IN ON SOME OTHER DEVICE") {
        // Force login and replace the old token with the new one
        Cookies.set("auth-token", result.newToken); // Save the new token
        navigate("/dashboard");
        setFormData({ email: "", password: "" });
       // toast.success("Logged in successfully on the current device.");
      } 
      //else {
        // Handle other login errors
       // toast.error(result?.data?.message || "Login failed");
      //}
    }
    
  };

  const handleLogout = async () => {

    if (!logoutuserid) return;
    const result = await handleLogoutAction(logoutuserid, dispatch);
    if (result) {
      // Clear the auth token from cookies
      Cookies.remove("auth-token");
      setLogoutUserId("");
      setShowLogoutButton(false);
      navigate("/");
    } else {
      // console.error("Logout failed");
    }
  };

  return (
    <Container
      fluid
      className="d-flex align-items-center justify-content-center"
      style={{ minHeight: "100vh", backgroundColor: "#f8f9fa" }}
    >
      <Card className="auth-card">
        <Row className="g-0">
          {/* Left Section - Login Form */}
          <Col md={6}>
            <Card.Body className="d-flex flex-column auth-form-body">
              <div className="mb-4 auth-form-logo">
                <img src={logo} alt="logo" />
              </div>
              <p>Please login to your account</p>
              <p>Enter your credentials</p>
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3" controlId="formEmail">
                  <Form.Label className="auth-form-label">
                    Email<span>*</span>
                  </Form.Label>
                  <Form.Control
                    className="auth-form-input m-0"
                    type="email"
                    placeholder="Enter email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    isInvalid={!!errors.email}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.email}
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-3" controlId="formPassword">
                  <Form.Label className="auth-form-label">
                    Password<span>*</span>
                  </Form.Label>
                  <InputGroup>
                  <Form.Control
                    // className="auth-form-input"
                    // type="password"
                    style={{
                   
                      borderRight: "none",
                     
                    }}
                    type={showPassword ? "text" : "password"}
                    placeholder="Enter your password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    isInvalid={!!errors.password}
                  />
                  
                  <InputGroup.Text
  onClick={togglePasswordVisibility}
  style={{
    cursor: "pointer",
    background: "transparent",
    borderLeft: "none", // Keep this outside the condition
    borderTopRightRadius: "6px",  // Adjust as needed
    borderBottomRightRadius: "6px",
    ...(errors.password ? { border: "1px solid red" } : {}), // Conditional border styling
  }}
>

                          {showPassword ? <FaEye /> : <FaEyeSlash />}{" "}
                          {/* Eye icon for visibility toggle */}
                        </InputGroup.Text>
                        <Form.Control.Feedback type="invalid">
                    {errors.password}
                  </Form.Control.Feedback>
                        </InputGroup>
                        <Form.Control.Feedback type="invalid">
                    {errors.password}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="auth-form-CheckForgot">
                  {/* Remember Me Checkbox */}
                  <Form.Check
                    type="checkbox"
                    label="Remember Me"
                    name="rememberMe"
                    // checked={formData.rememberMe}
                    // onChange={handleChange}
                    className="remember-me-checkbox"
                  />

                  {/* Forgot Password Link */}
                  <a href="/forgot-password" className="forgot-password">
                    Forgot Password?
                  </a>
                </Form.Group>

                {/* <Button
                  type="submit"
                  className="w-100 auth-form-btn"
                  style={{ backgroundColor: "#56934e", border: "#56934e" }}
                >
                  Login
                </Button> */}

                {showLogoutButton ? (
                  <Button
                    type="button"
                    className="w-100 auth-form-btn"
                    style={{ backgroundColor: "#d9534f", border: "#d9534f" }}
                    onClick={handleLogout}
                  >
                    Logout From Other Devices
                  </Button>
                ) : (
                  <Button
                    type="submit"
                    className="button w-100 auth-form-btn"
                    //style={{ backgroundColor: "#56934e", border: "#56934e" }}
                  >
                    Login
                  </Button>
                )}
              </Form>
            </Card.Body>
          </Col>

          {/* Right Section - Static Image */}
          <Col
            md={6}
            className="d-flex justify-content-center align-items-center"
          >
            <div
              className="h-100 w-100"
              style={{
                backgroundImage: `url(${IMAGES.loginFormImage})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                borderRadius: "0 15px 15px 0",
              }}
            ></div>
          </Col>
        </Row>
      </Card>
    </Container>
  );
}

export default Login;
